import { render, staticRenderFns } from "./member_list.vue?vue&type=template&id=52bd0192&scoped=true"
import script from "./member_list.vue?vue&type=script&lang=js"
export * from "./member_list.vue?vue&type=script&lang=js"
import style0 from "./member_list.vue?vue&type=style&index=0&id=52bd0192&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bd0192",
  null
  
)

export default component.exports